import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { createTheme, ThemeProvider  } from '@mui/material/styles';

const theme = createTheme({palette: {primary: {main: 'rgba(5, 30, 115, 1)'}}})

ReactDOM.render(
    <React.StrictMode>
    <ThemeProvider theme={theme}>
    <App />
    </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root')
  );
     
  